module.exports = __webpack_public_path__ + "media/images/orni_quiz/favicon-774d8c33fa141e2c7ebdf284a888de49.png";